import React,{Component} from 'react'
import CheeseburgerMenu from 'cheeseburger-menu'
import HamburgerMenu from 'react-hamburger-menu'
import MenuContent from './MenuContent'
import Logo from './Logo'

class Hamburger extends Component{
    constructor(props){
        super(props)
        this.state = {
            menuOpen: false,
        }
    }
    openMenu(){
        this.setState({ menuOpen:true })
    }
    closeMenu(){
        this.setState({ menuOpen:false })
    }
    render(){
        return (
            <React.Fragment>
                <CheeseburgerMenu
                    isOpen={this.state.menuOpen}
                    closeCallback={this.closeMenu.bind(this)}>
                    <Logo />    
                    <MenuContent closeCallback={this.closeMenu.bind(this)}/>
                </CheeseburgerMenu>
                <div className='hamburger'>
                    <HamburgerMenu
                        isOpen={this.state.menuOpen}
                        menuClicked={this.openMenu.bind(this)}
                        width={32}
                        height={18}
                        strokeWidth={3}
                        rotate={0}
                        color='white'
                        borderRadius={0}
                        animationDuration={0.45}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default Hamburger